export enum FIELDS {
  SELECTED_OFFER = 'selectedOffer',
  SELECTED_OPERATOR = 'selectedOperator'
}
